import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import CtaStyle2 from '../Cta/CtaStyle2';
import AboutStyle6 from '../About/AboutStyle6';
import CardStyle3 from '../Card/CardStyle3';
import { pageTitle } from '../../helpers/PageTitle';

export default function AfterSalesSupportPage() {
  pageTitle('After-Sales Support - Soketry Solutions');

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Enhancing Customer Satisfaction with <br /> Comprehensive After-Sales Support"
        subTitle="After-Sales Support"
        shape="shape_3"
      />
      <Spacing lg="75" md="60" />
      <div className="cs_service_info">
        <div className="container">
          <div className="row align-items-center cs_gap_y_40">
            <div className="col-lg-6">
              <div
                className="cs_service_info_thumb cs_bg_filed"
                style={{
                  backgroundImage: 'url("/images/after-sales/after-sales-1.jpg")',
                }}
              />
            </div>
            <div className="col-lg-6">
              <div className="row cs_gap_y_40">
                <div className="col-sm-6">
                  <CardStyle3
                    number="01"
                    title="Warranty Services"
                    subTitle="We offer comprehensive warranty services, ensuring that any issues with your products are swiftly addressed and resolved."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="02"
                    title="Technical Support"
                    subTitle="Our expert technical support team is available to assist you with any technical queries or problems you might encounter."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="03"
                    title="Regular Maintenance"
                    subTitle="We provide regular maintenance services to keep your systems running smoothly, preventing future issues."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="04"
                    title="Upgrades and Updates"
                    subTitle="Stay up-to-date with the latest technology as we offer upgrades and updates to enhance your systems’ performance over time."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
      <AboutStyle6
        thumbnailSrc="/images/after-sales/after-sales-2.jpg"
        title="Dedicated to Your Success"
        subTitle="Our After-Sales Support is dedicated to ensuring your satisfaction and maximizing the value of your investment with us."
        featureList={[
          'Comprehensive Warranties',
          'Expert Technical Support',
          'Proactive Maintenance Services',
          'Future-proof Upgrades'
        ]}
        btnText="Explore Our Projects"
        btnUrl="/portfolio"
      />
      <Spacing lg="150" md="80" />
      <CtaStyle2
        title="Need Assistance with Your Products?"
        btnText="Contact Support"
        btnUrl="/contact"
      />
      <Spacing lg="150" md="80" />
    </>
  );
}
